const formatDate = (date: string) => {
  const split = date.split('T');
  const regex = /-/gi;
  return split[0].replace(regex, '/');
};

export { formatDate };
